










































import { EMenuTypes } from "@/core/dataTypes/enum/menuTypes.enum";
import { computed, defineComponent, ref } from "@vue/composition-api";
import MenuList from "@/components/headers/MenuList/MenuList.vue";

export default defineComponent({
  name: "DropDownMenu",
  components: {
    MenuList,
  },
  props: {
    menuData: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const routeParams = computed(() => root.$route.params);
    const menu = ref<boolean>();
    const clickedOnMenu = (value: boolean) => {
      menu.value = value;
    };
    const closeMenu = () => {
      menu.value = !menu.value;
    };

    return {
      EMenuTypes,
      menu,
      clickedOnMenu,
      closeMenu,
      routeParams,
    };
  },
});
